import { render, staticRenderFns } from "./FeelingVibrationExperienceStep.vue?vue&type=template&id=35cc890e&scoped=true&"
import script from "./FeelingVibrationExperienceStep.vue?vue&type=script&lang=ts&"
export * from "./FeelingVibrationExperienceStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cc890e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer})
